import { useTranslation } from 'react-i18next'

import { FlatAsyncMultiValuedList } from '../../../Flat'
import { ListCell } from '../ListCell'

function TableAsyncFlatListCell({
  List = FlatAsyncMultiValuedList,
  excludeId,
  id,
  value,
  valuePrefixTextKey = 'Flat.FlatNumberKey',
  ...cellProps
}) {
  const { t } = useTranslation()

  const apiParams = {
    exclude_id: excludeId,
    inhabitant: id,
  }

  const preparedValue = value
    ? [
        {
          children:
            valuePrefixTextKey && value.name
              ? `${t(valuePrefixTextKey)} ${value.name}`
              : value.name,
        },
        ...Array.from({ length: value.count - 1 }),
      ]
    : null

  return (
    <ListCell
      {...cellProps}
      List={List}
      count={value?.count}
      listProps={{ apiParams, valuePrefixTextKey }}
      value={preparedValue}
    />
  )
}

export default TableAsyncFlatListCell
